/* eslint-disable */
export default {
  ringing: 'Chamada recebida',
  callConnected: 'Chamada conectada',
} as const;

// @key: @#@"ringing"@#@ @source: @#@"Incoming call"@#@
// @key: @#@"callConnected"@#@ @source: @#@"Call connected"@#@
